import * as React from 'react'
import { Toolbar, SaveButton, DeleteButton, usePermissions } from 'react-admin'
import { Box, ButtonBase, Typography } from '@material-ui/core'
import { CustomForm } from './CustomForm'

export const TabbedForm = ({ labels, pages, ...props }) => {
  const [formIndex, setFormIndex] = React.useState(0)
  const LABELS = labels
  const { permissions } = usePermissions()
  return (
    <CustomForm
      {...props}
      validateOnBlur={true}
      render={(formProps) => (
        <form>
          <Box display="flex">
            <Box display="flex" flexDirection="column" p={2} minWidth={150}>
              {LABELS.map((label, i) => (
                <ButtonBase
                  key={label}
                  onClick={() => {
                    formProps.valid && setFormIndex(i)
                  }}
                  style={{ padding: '10px 20px', justifyContent: 'flex-start' }}
                >
                  <Typography
                    style={{ fontWeight: formIndex === i ? 'bold' : 'normal' }}
                  >
                    {label}
                  </Typography>
                </ButtonBase>
              ))}
            </Box>
            <Box flex={1} minHeight={300} p={2}>
              {pages.map((Page, i) => (
                <Box
                  key={i}
                  style={{ display: formIndex === i ? 'block' : 'none' }}
                >
                  <Typography variant="h6">{LABELS[i]}</Typography>
                  <Box my={2} />
                  <Page {...formProps} visible={formIndex === i} />
                </Box>
              ))}
            </Box>
          </Box>

          <Toolbar>
            <Box display="flex" justifyContent="space-between" width="100%">
              <div></div>
              {/* <Box>
                {formIndex > 0 && (
                  <Button
                    onClick={() => setFormIndex(formIndex - 1)}
                    variant="contained"
                    label="prev"
                  />
                )}
              </Box> */}
              <div>
                <SaveButton
                  handleSubmitWithRedirect={formProps.handleSubmit}
                  submitOnEnter={true}
                />
                <SaveButton
                  label={props.record?.archived_at ? 'Unarchive' : 'Archive'}
                  submitOnEnter={false}
                  variant="text"
                  transform={(data) => ({
                    ...data,
                    archived_at: props.record.archived_at
                      ? null
                      : new Date().toISOString(),
                  })}
                  handleSubmitWithRedirect={() => {
                    if (
                      !window.confirm(
                        `Are you sure you want to ${
                          props.record?.archived_at ? 'unarchive' : 'archive'
                        } this?`,
                      )
                    )
                      return false
                    return formProps.handleSubmit()
                  }}
                />

                {permissions?.includes('admin') && (
                  <DeleteButton
                    undoable={props.undoable}
                    // record={props.record}
                  />
                )}
              </div>
              {/* <Button
                  onClick={() => {
                    formProps.valid && setFormIndex(formIndex + 1)
                  }}
                  variant="contained"
                  label="next"
                /> */}
            </Box>
          </Toolbar>
        </form>
      )}
    />
  )
}
